/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * Platform-specific spacing constants for keyboard awareness.
 * These values control how much extra space is added when the keyboard appears
 * to ensure text inputs remain visible and properly positioned.
 */

// Android requires more spacing due to different keyboard behavior
export const KEYBOARD_EXTRA_SPACING_ANDROID = 140;

// iOS requires less spacing as the system handles more keyboard management natively
export const KEYBOARD_EXTRA_SPACING_IOS = 20;

// Android requires more height spacing due to different keyboard behavior
export const KEYBOARD_EXTRA_HEIGHT_SPACING_ANDROID = 140;

// iOS requires less height spacing as the system handles more keyboard management natively
export const KEYBOARD_EXTRA_HEIGHT_SPACING_IOS = 0;
